import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SEOHelmet from '../../components/SEOHelmet';
import { motion } from 'framer-motion';
import PublicNavigation from '../../components/ui/PublicNavigation';
import UnifiedFooter from '../../components/ui/UnifiedFooter';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ContactSection from '../shipping-information/components/ContactSection';
import ChatWidget from '../../components/ui/ChatWidget';
import NewsletterBanner from '../../components/ui/NewsletterBanner';

const MaritimeTransportBlogHub = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
  { id: 'all', name: 'Tous les articles' },
  { id: 'shipping', name: 'Transport Maritime' },
  { id: 'guides', name: 'Guides Pratiques' },
  { id: 'news', name: 'Actualités' }];



  // Featured Article
  const featuredArticle = {
    title: "Logistique France – Côte d\'Ivoire : piloter vos expéditions depuis un véritable cockpit digital",
    category: "Logistique Digitale",
    date: "15 Février 2026",
    readTime: "8 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab98dbc9-1771190424374.png",
    excerpt: "Découvrez comment ADT Express transforme la logistique France – Côte d'Ivoire avec une plateforme digitale professionnelle. Suivi temps réel, gestion documentaire, certificats EX1, analyse des coûts.",
    featured: true,
    link: "/blog/logistique-cockpit-digital"
  };

  const articles = [
  {
    title: "Logistique France – Côte d\'Ivoire : piloter vos expéditions depuis un véritable cockpit digital",
    category: "Logistique Digitale",
    categoryId: "guides",
    date: "15 Février 2026",
    readTime: "8 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab98dbc9-1771190424374.png",
    excerpt: "Découvrez comment ADT Express transforme la logistique France – Côte d\'Ivoire avec une plateforme digitale professionnelle.",
    link: "/blog/logistique-cockpit-digital"
  },
  {
    title: "Les 10 choses à savoir avant d\'envoyer un colis en Côte d\'Ivoire",
    category: "Guide Pratique",
    categoryId: "guides",
    date: "5 Février 2026",
    readTime: "5 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d3049e20-1764722951490.png",
    excerpt: "Découvrez les points essentiels à connaître pour un envoi réussi vers la Côte d'Ivoire. De la préparation de votre colis aux formalités douanières, nous vous guidons pas à pas.",
    featured: false
  },
  {
    title: "Barrique noire vs barrique bleue : laquelle choisir ?",
    category: "Guide Pratique",
    categoryId: "guides",
    date: "28 Janvier 2026",
    readTime: "4 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e5dc1c01-1779994933523.png",
    excerpt: "Comparatif détaillé pour vous aider à choisir la barrique adaptée à vos besoins."
  },
  {
    title: "Témoignage : Comment j\'ai envoyé 3 barriques à ma famille à Abidjan",
    category: "Témoignages",
    categoryId: "guides",
    date: "20 Janvier 2026",
    readTime: "6 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b579e038-1780788246471.png",
    excerpt: "L'expérience d'Aminata, cliente fidèle d'ADT Express depuis 2 ans."
  },
  {
    title: "Délais et transit : combien de temps pour un envoi maritime vers Abidjan ?",
    category: "Transport Maritime",
    categoryId: "shipping",
    date: "15 Janvier 2026",
    readTime: "5 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f345113c-1780788246376.png",
    excerpt: "Tout savoir sur les délais de livraison et le suivi de votre envoi maritime."
  },
  {
    title: "Que peut-on envoyer dans une barrique vers la Côte d\'Ivoire ?",
    category: "Guide Pratique",
    categoryId: "guides",
    date: "10 Janvier 2026",
    readTime: "4 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1818c4e14-1768320572274.png",
    excerpt: "Liste complète des articles autorisés et interdits pour votre envoi."
  },
  {
    title: "Nouveau : Prochain départ le 25 février 2026",
    category: "Actualités",
    categoryId: "news",
    date: "5 Janvier 2026",
    readTime: "2 min",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1799d80b8-1766572607884.png",
    excerpt: "Réservez dès maintenant votre place dans notre prochain conteneur vers Abidjan."
  }];



  const structuredDataBlog = {
    "@context": "https://schema.org",
    "@graph": [
    {
      "@type": "Blog",
      "name": "Blog ADT Express - Transport Maritime France Côte d\'Ivoire",
      "description": "Guides pratiques, conseils et actualités sur l'envoi de colis vers la Côte d'Ivoire",
      "url": "https://www.adtexpress.fr/blog",
      "publisher": {
        "@type": "Organization",
        "name": "ADT Express"
      }
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://www.adtexpress.fr"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": "https://www.adtexpress.fr/blog"
      }]

    }]

  };

  // Filter articles based on selected category and search query
  const filteredArticles = articles?.filter((article) => {
    const matchesCategory = selectedCategory === 'all' || article?.categoryId === selectedCategory;
    const matchesSearch = searchQuery === '' ||
    article?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    article?.excerpt?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <SEOHelmet
        title="Blog Transport Maritime France Côte d'Ivoire | Guides Envoi Barrique Abidjan - ADT Express"
        description="Guides pratiques envoi colis Côte d'Ivoire : comment envoyer barrique Abidjan, délais fret maritime Paris Abidjan, conseils transport conteneur France CI. Actualités logistique."
        keywords={"guide envoi Côte d'Ivoire, conseils barrique Abidjan, blog fret maritime Paris Abidjan, actualités transport conteneur France CI, astuces envoi diaspora ivoirienne, envoyer barrique Côte d'Ivoire, groupage maritime, tarif envoi Abidjan"}
        canonicalUrl="https://www.adtexpress.fr/blog"
        structuredData={structuredDataBlog} />
      <Helmet>
        <title>Blog ADT Express | Conseils et guides transport maritime vers Abidjan</title>
        <meta name="description" content="Conseils, guides pratiques et actualités sur le transport maritime vers la Côte d'Ivoire. Découvrez nos articles pour réussir vos envois depuis Paris." />
        <meta name="keywords" content="blog transport maritime, guide envoi Abidjan, conseils fret maritime, diaspora ivoirienne" />
        <script type="application/ld+json">
          {JSON.stringify(structuredDataBlog)}
        </script>
      </Helmet>
      <PublicNavigation />
      <NewsletterBanner />
      {/* Header Section - Clean White Background */}
      <section className="bg-white py-12 px-4 border-b pt-44">
        <div className="container mx-auto max-w-6xl text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Blog ADT Express
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Conseils, guides pratiques et actualités sur le transport maritime vers la Côte d'Ivoire
          </p>
        </div>
      </section>
      {/* Search & Tab Filters */}
      <section className="bg-white py-6 px-4 border-b sticky top-0 z-10 shadow-sm">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
            {/* Search Bar */}
            <div className="relative w-full md:w-96">
              <Icon name="Search" className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher un article..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent" />
              
              
            </div>

            {/* Tab-Style Categories */}
            <div className="flex gap-1 overflow-x-auto pb-2 md:pb-0">
              {categories?.map((category) =>
              <button
                key={category?.id}
                onClick={() => setSelectedCategory(category?.id)}
                className={`px-6 py-2.5 font-medium whitespace-nowrap transition-all relative ${
                selectedCategory === category?.id ?
                'text-green-700' : 'text-gray-600 hover:text-gray-900'}`
                }>
                
                  {category?.name}
                  {selectedCategory === category?.id &&
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-700" />
                }
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Featured Article Section */}
      <section className="py-12 px-4 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto max-w-6xl">
          <div className="flex items-center gap-2 mb-6">
            <Icon name="Star" className="w-6 h-6 text-yellow-500 fill-yellow-500" />
            <h2 className="text-2xl font-bold text-gray-900">Article en vedette</h2>
          </div>
          <Link to={featuredArticle?.link || "/maritime-transport-blog-article"}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-[1.01]">
              <div className="grid md:grid-cols-2 gap-0">
                {/* Featured Article Image */}
                <div className="h-64 md:h-full overflow-hidden relative">
                  <img
                    src={featuredArticle?.image}
                    alt="Transport maritime vers Abidjan - Port autonome d'Abidjan"
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" />
                  <div className="absolute top-4 left-4">
                    <span className="bg-yellow-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                      ⭐ EN VEDETTE
                    </span>
                  </div>
                </div>

                {/* Featured Article Content */}
                <div className="p-8 md:p-10 flex flex-col justify-center">
                  <span className="inline-block bg-green-100 text-green-700 px-4 py-2 rounded-lg text-sm font-semibold mb-4 w-fit">
                    {featuredArticle?.category}
                  </span>
                  <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 leading-tight">
                    {featuredArticle?.title}
                  </h3>
                  <p className="text-gray-600 text-base mb-6 leading-relaxed">
                    {featuredArticle?.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-2">
                      <Icon name="Calendar" className="w-4 h-4" />
                      <span>{featuredArticle?.date}</span>
                    </div>
                    <span>•</span>
                    <div className="flex items-center gap-2">
                      <Icon name="Clock" className="w-4 h-4" />
                      <span>{featuredArticle?.readTime} de lecture</span>
                    </div>
                  </div>
                  <div className="mt-6">
                    <Button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold inline-flex items-center gap-2">
                      Lire l'article
                      <Icon name="ArrowRight" className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>
          </Link>
        </div>
      </section>
      {/* Articles Grid - 3 Columns */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          {filteredArticles?.length === 0 ?
          <div className="text-center py-12">
              <p className="text-gray-500 text-lg">Aucun article trouvé pour cette recherche.</p>
            </div> :

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles?.map((article, index) =>
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}>
              
                  <Link to={article?.link || "/maritime-transport-blog-article"}>
                    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-[1.02] h-full flex flex-col">
                      {/* Article Image */}
                      <div className="h-48 overflow-hidden">
                        <img
                      src={article?.image}
                      alt={`Illustration pour ${article?.title}`}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />
                    
                      </div>

                      {/* Article Content */}
                      <div className="p-6 flex flex-col flex-grow">
                        <span className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-md text-xs font-medium mb-3 w-fit">
                          {article?.category}
                        </span>
                        <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                          {article?.title}
                        </h3>
                        <p className="text-gray-600 text-sm mb-4 line-clamp-2 flex-grow">
                          {article?.excerpt}
                        </p>
                        <div className="flex items-center gap-3 text-xs text-gray-500 pt-4 border-t">
                          <span>{article?.date}</span>
                          <span>•</span>
                          <span>{article?.readTime} de lecture</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.div>
            )}
            </div>
          }
        </div>
      </section>
      {/* Newsletter Section - Gray Background */}
      <section className="py-16 px-4 bg-gray-100">
        <div className="container mx-auto max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center">
            
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              Recevez nos conseils et offres par email
            </h2>
            <p className="text-gray-600 mb-8">
              Un email par mois, pas de spam. Désabonnement en un clic.
            </p>
            <form className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
              <input
                type="email"
                placeholder="Votre adresse email"
                className="flex-1 px-6 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-transparent" />
              
              
              <Button type="submit" className="bg-green-700 hover:bg-green-800 text-white font-semibold px-8 py-3">
                S'inscrire
              </Button>
            </form>
          </motion.div>
        </div>
      </section>
      {/* CTA Box for Quote */}
      <section className="py-12 px-4 bg-gray-50">
        <div className="container mx-auto max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 md:p-12 text-center shadow-2xl">
            <div className="max-w-2xl mx-auto">
              <div className="bg-white/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Icon name="FileText" className="w-10 h-10 text-white" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Besoin d'un devis pour votre prochaine expédition ?
              </h2>
              <p className="text-lg text-green-50 mb-8">
                Que ce soit pour un <strong>envoi colis Côte d'Ivoire</strong> ou du <strong>fret maritime Paris Abidjan</strong> en volume, 
                obtenez votre estimation personnalisée en quelques clics.
              </p>
              <Link to="/public-maritime-order-page">
                <Button size="lg" className="bg-white text-green-700 hover:bg-green-50 font-bold shadow-lg px-8 py-4 text-lg">
                  <Icon name="Calculator" className="mr-2" />
                  Demander un devis gratuit
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <ContactSection />
        </div>
      </section>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/33651988621"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:shadow-3xl transition-all z-50 group"
        aria-label="Contactez-nous sur WhatsApp">
        
        <Icon name="MessageCircle" className="w-7 h-7" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Contactez-nous sur WhatsApp
        </span>
      </a>
      {/* Chat Widget */}
      <ChatWidget />
      <UnifiedFooter />
    </div>);









};

export default MaritimeTransportBlogHub;